export default __webpack_public_path__ + "b0003018b7bb81b742a499160ed4ca89.png";